module.exports = __webpack_public_path__ + "img/swyycy.dd3fa4e4.png";